export const content = [
	{
		id: '1',
		title: 'Dashboard Overview',
		link: 'https://www.youtube.com/watch?v=-2f2maWV1dA',
	},
	{
		id: '2',
		title: 'Your Journey into Tech Starts Here',
		link: 'https://youtu.be/sB34dI5k1yo',
	},
	{
		id: '3',
		title: 'HTML, CSS & JavaScript',
		link: 'https://youtu.be/bNlkO5iXvCA',
	},
	{
		id: '4',
		title: 'UIUX overview',
		link: 'https://youtu.be/CXQC6HoktjY',
	},
];
